import { QueryClient } from '@tanstack/react-query';

// Single query client for the whole app. Defaults are conservative
// (short staleTime, one retry) — call sites that want the old
// "instant paint from cache, refresh in background" behavior set a
// longer staleTime explicitly per query, rather than this being the
// app-wide default.
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 0,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});
